/*
This file is for handle VideoPlayer.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 29/11/2017 07:14 PM
*/

/* global document, L */

import View from './View';
import ViewProperties from './ViewProperties';
// import Bar from './Bar';
import Element from './Element';
import localization from './../Localization';

/*
 * VideoPlayer represents a video component that shows either a local or a remote video.
 * Ex.: const player = VideoPlayer({id: id, stream: stream, elementID: elementID});
 * A VideoPlayer is also a View component.
 */
const VideoPlayer = (spec) => {
  const that = View({});

  // Variables
  const player = ViewProperties().player.default;
  if (Element.checkParam(spec.options) && Element.checkParam(spec.options.player)) {
    const playerOptions = spec.options.player;
    if (Element.checkParam(playerOptions.autoplay)) { player.autoplay = playerOptions.autoplay; }
    if (Element.checkParam(playerOptions.name)) { player.name = playerOptions.name; }
    if (Element.checkParam(playerOptions.nameDisplayMode)) { player.nameDisplayMode = playerOptions.nameDisplayMode; }
    if (Element.checkParam(playerOptions.frameFitMode)) { player.frameFitMode = playerOptions.frameFitMode; }
    if (Element.checkParam(playerOptions.skin)) { player.skin = playerOptions.skin; }
    if (Element.checkParam(playerOptions.class)) { player.class = playerOptions.class; }
    if (Element.checkParam(playerOptions.height)) { player.height = playerOptions.height; }
    if (Element.checkParam(playerOptions.width)) { player.width = playerOptions.width; }
    if (Element.checkParam(playerOptions.minHeight)) { player.minHeight = playerOptions.minHeight; }
    if (Element.checkParam(playerOptions.minWidth)) { player.minWidth = playerOptions.minWidth; }
    if (Element.checkParam(playerOptions.aspectRatio)) { player.aspectRatio = playerOptions.aspectRatio; }
    if (Element.checkParam(playerOptions.volume)) { player.volume = playerOptions.volume; }
    if (Element.checkParam(playerOptions.backgroundImg)) { player.backgroundImg = playerOptions.backgroundImg; }
    if (Element.checkParam(playerOptions.media)) { player.media = playerOptions.media; }
    if (Element.checkParam(playerOptions.loader)) {
      const loaderProp = playerOptions.loader;
      if (Element.checkParam(loaderProp.url)) { player.loader.url = loaderProp.url; }
      player.loader.show = loaderProp.show;
      if (Element.checkParam(loaderProp.class)) { player.loader.class = loaderProp.class; }
      if (Element.checkParam(loaderProp.style)) { player.loader.style = loaderProp.style; }
    }
  }

  // VideoPlayer ID
  that.id = spec.id;
  // Stream that the VideoPlayer will play
  that.stream = spec.stream.stream;
  // DOM element in which the VideoPlayer will be appended
  that.elementID = spec.elementID;

  // Private functions
  that.abwd = {};
  that.abwd.notification = true;
  that.abwd.lang = 'en';


  if (Element.checkParam(spec.options) &&
    Element.checkParam(spec.options.player) &&
    Element.checkParam(spec.options.player.abwd)) {
    const abwdOption = spec.options.player.abwd;
    if (abwdOption.enabled === false) { that.abwd.notification = false; } else if (abwdOption.enabled === true && abwdOption.notification === 'sdk') {
      that.abwd.notification = true;
      if (abwdOption.language === 'en' || abwdOption.language === 'zh') {
        that.abwd.lang = abwdOption.language;
      } else { that.abwd.lang = 'en'; }
    } else if (abwdOption.enabled === true && abwdOption.notification === 'app') {
      that.abwd.notification = false;
      that.abwd.lang = '';
    }
  }

  const container = Element.getById(spec.elementID);
  container.style.height = player.height;
  container.style.width = player.width;//that.id
  container.style.minHeight = player.minHeight;
  container.style.minWidth = player.minWidth;


  const applyRatio = (ratio, width, height, reverse) => {
    const condition = !reverse ? width * (1 / ratio) < height : width * (1 / ratio) > height;
    if (condition) {
      that.video.style.width = `${width}px`;
      that.video.style.height = `${(1 / ratio) * width}px`;

      that.video.style.top = `${-((((1 / ratio) * width) / 2) - (height / 2))}px`;
      that.video.style.left = '0px';
    } else {
      that.video.style.height = `${height}px`;
      that.video.style.width = `${ratio * height}px`;

      that.video.style.left = `${-(((ratio * height) / 2) - (width / 2))}px`;
      that.video.style.top = '0px';
    }
  };

  // Public functions

  // It will stop the VideoPlayer and remove it from the HTML
  that.destroy = () => {
    console.log('video player destroy requested');
    that.video.pause();
    delete that.resizer;
    that.parentNode.removeChild(that.div);
  };

  that.resize = () => {
    const width = that.container.offsetWidth;
    const height = that.container.offsetHeight;

    if (spec.stream.screen || spec.options.crop === false || spec.stream.canvas) {
      applyRatio(16 / 9, width, height, false);
    } else if (width !== that.containerWidth || height !== that.containerHeight) {
      applyRatio(4 / 3, width, height, true);
    }
    that.containerWidth = width;
    that.containerHeight = height;
  };

  /* window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
      document.getElementById(key).value = unescape(value);
  }); */

  let elementId = spec.stream.setPlayerId(spec.vroom ? spec.vroom : spec.stream.room);
  // Container
  that.div = Element({ name: 'div', id: `${elementId.player}`, class: 'vcx_player ' + player.skin + '_vcx_player' });

  // Loader icon
  if (player.loader.url) {
    that.loader = Element({
      name: 'img', src: player.loader.url, id: `back_${that.id}`, class: `vcx_player_loader ${player.loader.class} ${player.skin}_vcx_player_loader`,
    });
    if (!player.loader.show) { that.loader.style.display = 'none'; }
  }


  //BackGround Image
  if (player.backgroundImg) {
    that.screenSaver = Element({
      name: 'img', src: player.backgroundImg, id: `screen_saver_${that.id}`, class: `vcx_player_screen_saver ${player.skin}_vcx_player_screen_saver`,
    });
    that.screenSaver.style.display = 'none';
  }


  // Video tag
  let elementOptions = { name: 'video', id: `${elementId.stream}`, class: `vcx_stream ${player.skin}_vcx_stream` };
  if (spec.extraPlayerOptions.autoplay) elementOptions.autoplay = spec.extraPlayerOptions.autoplay;
  if (spec.extraPlayerOptions.playsinline) elementOptions.playsinline = spec.extraPlayerOptions.playsinline;
  that.video = Element(elementOptions);
  if (spec.stream.local) { that.video.volume = 0; }

  if (that.elementID !== undefined) {
    // Check for a passed DOM node.
    if (typeof that.elementID === 'object' &&
      typeof that.elementID.appendChild === 'function') {
      that.container = that.elementID;
    } else {
      that.container = Element.getById(that.elementID);
    }
  } else {
    that.container = document.body;
  }
  that.container.appendChild(that.div);

  that.parentNode = that.div.parentNode;


  // player stats button

  let statsContainer = document.createElement('div');
  statsContainer.setAttribute('id', `stats-container-${that.id}`);
  statsContainer.setAttribute('class', 'stats-container');
  statsContainer.setAttribute('style', 'display:none;');

  let bwNotContainer = document.createElement('div');
  bwNotContainer.setAttribute('id', `bw-notif-${that.id}`);
  bwNotContainer.setAttribute('class', 'bw-notification');
  bwNotContainer.setAttribute('style', 'display:none;position:absolute;z-index:3;padding:5px 10px;top:50%;right:50%;transform:translateX(50%);background:rgba(0,0,0,0.29);border-radius:5px;color:rgb(255,255,255)');

  let playerButton = document.createElement('div');
  playerButton.setAttribute('id', `stats-button-${that.id}`);
  playerButton.setAttribute('class', 'stats-button');
  playerButton.setAttribute('title', 'Click to see stats');
  playerButton.innerHTML = window.statsIcon;

  statsContainer.appendChild(playerButton);

  let statsOverlay = document.createElement('div');
  statsOverlay.setAttribute('class', 'stats-overlay');
  statsOverlay.setAttribute('id', `stats-overlay-${that.id}`);
  statsOverlay.setAttribute('style', `display: none;
            position: absolute;z-index: 3;
            padding: 5px;top: 0px;right: 0px;
            background: linear-gradient(90deg,rgb(204 41 42 / 62%),#a20a90b0);
            border-radius: 5px;color: #fff;width: 100%;`
            );

  let statsOverlayInner = document.createElement('div');
  statsOverlayInner.setAttribute('class', 'stats-overlay-inner');
  statsOverlayInner.setAttribute('id', `stats-overlay-inner-${that.id}`);
  // statsOverlayInner.setAttribute('style', `display:flex;flex-direction:row;`);


  let leftPartition = document.createElement('div'),
    rightPartition = document.createElement('div');
  leftPartition.setAttribute('class', 'stats-left-partition');
  leftPartition.setAttribute('id', `stats-left-part-${that.id}`);

  rightPartition.setAttribute('class', 'stats-right-partition');
  rightPartition.setAttribute('id', `stats-right-part-${that.id}`);

  playerButton.addEventListener('click', () => {
    if (statsOverlay.style.display === 'none'){
      statsOverlay.style.display = 'block';
    }
    else{
      statsOverlay.style.display = 'none';
    }
  });

  that.div.parentNode.style.position = 'relative';
  // Appending Stats container to main player container
  that.div.parentNode.appendChild(statsContainer);
  // appending overlay to container
  that.div.parentNode.appendChild(statsOverlay);
  statsOverlay.appendChild(statsOverlayInner);

  //Appending bw notification button
  that.div.parentNode.appendChild(bwNotContainer);


  // partitions of overlay
  statsOverlayInner.appendChild(leftPartition);
  statsOverlayInner.appendChild(rightPartition);


  if (that.loader) {
    that.div.appendChild(that.loader);
  }
  if (that.screenSaver) {
    that.div.appendChild(that.screenSaver);
  }

  that.div.appendChild(that.video);

  that.containerWidth = 0;
  that.containerHeight = 0;

  if (spec.options && spec.options.resizer !== false) {
    that.resizer = L.ResizeSensor(that.container, that.resize);

    that.resize();
  }

  // Bottom Bar
  if (spec.options.bar !== false) {
    // that.bar = Bar({
    //   elementID: `${elementId.player}`,
    //   id: that.id,
    //   stream: spec.stream,
    //   media: that.video,
    //   options: spec.options
    // });
  } else {
    // Expose a consistent object to manipulate the media.
    that.media = that.video;
  }
  //attachMediaStream(that.video,that.stream);
  that.video.srcObject = that.stream;
  // show or hide stats
  that.ShowSessionStats = (statsEnabled) => {
    if (statsEnabled === true) {
      // show stats UI
      statsContainer.setAttribute('style', 'display:block;');
      statsOverlay.setAttribute('style', 'display:block;position: absolute;z-index:3;padding: 5px;top:0;right:0;background: rgba(20, 198, 239, 0.75);');
    } else {
      // hide stats UI
      statsContainer.setAttribute('style', 'display:none;');
      statsOverlay.setAttribute('style', 'display:none;position: absolute;z-index:3;padding: 5px;top:0;right:0;background: rgba(20, 198, 239, 0.75);');
    }
  };

  that.setBwAlert = (enabled, type, name) => {
    if (that.abwd.notification === false) { return; }

    if (enabled === true) {
      if (type === 'subscriber') { bwNotContainer.innerText = localization.abwd[that.abwd.lang].bw_alert_subscriber; } else { bwNotContainer.innerText = name + localization.abwd[that.abwd.lang].bw_alert_publisher; }
      bwNotContainer.setAttribute('style', 'display:block;position:absolute;z-index:3;padding:5px 10px;top:50%;right:50%;transform:translateX(50%);background:rgba(0,0,0,0.29);border-radius:5px;color:rgb(255,255,255)');
      //bwNotContainer.display = 'block';
    } else { bwNotContainer.setAttribute('style', 'display:none;position:absolute;z-index:3;padding:5px 10px;top:50%;right:50%;transform:translateX(50%);background:rgba(0,0,0,0.29);border-radius:5px;color:rgb(255,255,255)'); }
    //bwNotContainer.display = none;
  };

  that.setVideoMutedMsg = (arg) => {
    if (that.abwd.notification === false) { return; }


    if (arg.videomuted === true && arg.reason === 'bw') {
      bwNotContainer.innerText = `${arg.name} ${localization.abwd[that.abwd.lang].video_muted}`;
      bwNotContainer.setAttribute('style', 'display:block;position:absolute;z-index:3;padding:5px 10px;top:50%;right:50%;transform:translateX(50%);background:rgba(0,0,0,0.29);border-radius:5px;color:rgb(255,255,255)');
    } else {
      bwNotContainer.setAttribute('style', 'display:none;position:absolute;z-index:3;padding:5px 10px;top:50%;right:50%;transform:translateX(50%);background:rgba(0,0,0,0.29);border-radius:5px;color:rgb(255,255,255)');
    }
  };

  return that;
};

export default VideoPlayer;


//////////////////
// WEBPACK FOOTER
// ./src/views/VideoPlayer.js
// module id = 139
// module chunks = 0



//////////////////
// WEBPACK FOOTER
// ./src/views/VideoPlayer.js
// module id = 162
// module chunks = 0